module.exports = __webpack_public_path__ + "static/media/vegan.2cb7d1b9.png";